import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Timer, X } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CountdownBanner() {
  const [promo, setPromo] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchPromo = async () => {
      try {
        const { data } = await axios.get(`${API}/promotions/active`);
        const banner = data.find((p) => p.type === "countdown_banner");
        if (banner) setPromo(banner);
      } catch (_e) { /* silently ignore */ }
    };
    fetchPromo();
  }, []);

  useEffect(() => {
    if (!promo?.end_date) return;
    const update = () => {
      const diff = new Date(promo.end_date) - new Date();
      if (diff <= 0) { setTimeLeft(null); return; }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setTimeLeft({ d, h, m, s });
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [promo]);

  if (!promo || !timeLeft || dismissed) return null;
  if (sessionStorage.getItem("countdown_dismissed")) return null;

  const close = () => {
    setDismissed(true);
    sessionStorage.setItem("countdown_dismissed", "1");
  };

  return (
    <div
      className="relative w-full py-2.5 px-4 flex items-center justify-center gap-4 text-sm font-medium z-40"
      style={{ background: promo.bg_color, color: promo.text_color }}
      data-testid="countdown-banner"
    >
      <Timer className="w-4 h-4 animate-pulse" />
      <span className="hidden sm:inline">{promo.title}</span>
      {promo.discount_text && <span className="font-black text-base">{promo.discount_text}</span>}
      <div className="flex items-center gap-1.5 font-mono">
        {timeLeft.d > 0 && <span className="bg-white/20 rounded px-1.5 py-0.5">{timeLeft.d}d</span>}
        <span className="bg-white/20 rounded px-1.5 py-0.5">{String(timeLeft.h).padStart(2, '0')}h</span>
        <span className="bg-white/20 rounded px-1.5 py-0.5">{String(timeLeft.m).padStart(2, '0')}m</span>
        <span className="bg-white/20 rounded px-1.5 py-0.5">{String(timeLeft.s).padStart(2, '0')}s</span>
      </div>
      <Link to={promo.cta_link || "/get-quote"} className="underline underline-offset-2 hover:opacity-80 font-semibold" data-testid="countdown-cta">
        {promo.cta_text || "Get Offer"}
      </Link>
      <button onClick={close} className="absolute right-3 top-1/2 -translate-y-1/2 hover:opacity-70" data-testid="countdown-close">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
